import sample_1 from './schoffe.jpg';

export const schoffeImpressions = {
    sample_1,
};
